import { OwaDate } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import getDatesOnEndPartChanged from './getDatesOnEndPartChanged';

/**
 * This function returns new start and end time based the change of the end date
 * It updates the end date and not the time.
 * Sets the end date to be start date if end date is set to before the start
 */

export default function getDatesOnEndDateChanged(
    prevStartDate: OwaDate,
    prevEndDate: OwaDate,
    newDate: OwaDate
): OwaDateRange | null {
    if (prevStartDate && prevEndDate && newDate) {
        return getDatesOnEndPartChanged(prevStartDate, prevEndDate.tz, newDate, prevEndDate);
    }
    return null;
}
